import { render, staticRenderFns } from "./ComponentsIndex.vue?vue&type=template&id=3e435688&"
import script from "./ComponentsIndex.vue?vue&type=script&lang=js&"
export * from "./ComponentsIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports